<label [for]="id">
  <input
    [id]="id"  
    type="radio"
    [name]="name"
    [value]="val"
    [checked]="checked"
    (change)="change($event.target.value)"
    (blur)="onTouched()"
    [disabled]="disabled"
    [class.disabled]="disabled"
    [class.validation]="validation"
    [class.pristine]="pristine"
    [class.dirty]="dirty"
    [class.touched]="touched"
    [class.invalid]="invalid"
    [class.valid]="valid" />
  <div class="v-input"></div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</label>
<div *ngIf="enableMessages" class="messages">
  <ng-content select="app-form-error"></ng-content>
</div>
